import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import MobileNavigation from './MobileNavigation'
import { PLATFORM_NAME } from '../../config/brand'

interface ResponsiveLayoutProps {
  children: React.ReactNode
}

const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false)
  const location = useLocation()

  // 检测屏幕尺寸
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  const isHomePage = location.pathname === '/home'

  if (!isMobile) {
    // 桌面端布局
    return (
      <div className="min-h-screen bg-gray-900">
        <Header />
        <div className="bg-gray-900">
          {children}
        </div>
      </div>
    )
  }

  // 移动端布局
  return (
    <div className="min-h-screen bg-gray-900">
      {!isHomePage && (
        <div className="fixed top-0 left-0 right-0 bg-gray-900 border-b border-gray-700 z-40 px-4 py-3 flex items-center justify-center">
          <span className="text-white text-xl font-bold lowercase tracking-wide">{PLATFORM_NAME}</span>
        </div>
      )}

      {/* 移动端内容区域 */}
      <div className={`bg-gray-900 pb-16 min-h-screen overflow-auto ${isHomePage ? 'pt-0' : 'pt-16'}`}>
        {children}
      </div>

      {/* 移动端底部导航 */}
      <MobileNavigation currentPath={location.pathname} />
    </div>
  )
}

export default ResponsiveLayout